import useCalendarBodyUpdateEvents from '../common/body/useCalendarBodyUpdateEvents';

const useStandaloneCalendarBodyUpdateEvents = () => {
  useCalendarBodyUpdateEvents((propertyUid) => [propertyUid]);
};

export default useStandaloneCalendarBodyUpdateEvents;
